import React from "react";
import PostSummaryItem from "./PostSummaryItem.js";
import Posts from "./posts.json";

const PostSummaryList = () => {
  return(
        <ul className="list-group">
          {
            Posts.map(post=>{
            return(
                <PostSummaryItem post={post}/>
            );
            })
          }
        </ul>
    );
}

export default PostSummaryList;